module.exports = __webpack_public_path__ + "static/media/academy_vertical.59a24700.png";